import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
// import TecholutionShortLogo from "@/assets/icons/techolutionShortLogo.svg";
import AIStarsIcon from "@/assets/icons/aiStarsIcon.svg";
import { Button } from "primereact/button";
import useToastStore from "@/shared/zustand/toastStore";
import useAuthStore from "@/shared/zustand/authStore";
// import { googleLogout } from "@react-oauth/google";
import { HOST_MODES } from "@/constants";
import useProjectStore from "@/shared/zustand/projectManagementStore";
import { useNavigate, useLocation } from "react-router-dom";
import { FolderOpen, FilePlus, Settings } from "lucide-react";
const SideBar = ({ activeHostMode, setShowModeOnboarding, modesHistory, 
// showModeOnboarding,
setCurrentHostMode, // Add this prop
selectActiveMode, openNewProject, openNewChat, }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const commonStyles = "w-full text-left rounded-[6px] py-3 px-4 border gap-x-3";
    const activeStyles = "bg-[#5928ED] text-white";
    const inactiveStyles = "bg-transparent text-[#838C95] border-[#D1D5DB]";
    const [activeButton, setActiveButton] = useState("home");
    const { showForm } = useProjectStore();
    const showToast = useToastStore((state) => state.showToast);
    const logout = useAuthStore((state) => state.logout);
    // have to rewrite this logic
    useEffect(() => {
        if (modesHistory.length > 0) {
            if (modesHistory[modesHistory.length - 1].mode === "")
                setActiveButton("home");
            else
                setActiveButton(modesHistory[modesHistory.length - 1].mode === activeHostMode
                    ? modesHistory[modesHistory.length - 1].mode
                    : "home");
        }
    }, [modesHistory]);
    const handleLogout = () => {
        try {
            // googleLogout(); // Clear Google session
            window.location.href =
                process.env.VITE_APPSEC_AUTH_BACKEND_URL +
                    "/cross-signout?callback_url=" +
                    window.location.origin +
                    "/login";
            // Clear Zustand state
            logout();
            showToast("success", "Success", "You have been logged out successfully");
        }
        catch (error) {
            showToast("error", "Error", "An error has occurred while sign out");
            console.error("Error while signout", error);
        }
    };
    const handleProjectNav = () => {
        if (location.pathname === "/settings") {
            navigate("/chat");
        }
        setActiveButton(HOST_MODES["Project Mode"]);
        setCurrentHostMode(HOST_MODES["Project Mode"]);
        selectActiveMode(HOST_MODES["Project Mode"], "SideBar", true);
    };
    // const handleDriveMode = () => {
    //   if (location.pathname === "/settings") {
    //     navigate("/chat");
    //   }
    //   setActiveButton(HOST_MODES["Drive Mode"]);
    //   setCurrentHostMode(HOST_MODES["Drive Mode"]);
    //   selectActiveMode(HOST_MODES["Drive Mode"], "SideBar", true);
    // };
    const handleModeOnboardingNav = () => {
        if (location.pathname === "/settings") {
            navigate("/chat");
        }
        setActiveButton(HOST_MODES["Mode Onboarding"]);
        setShowModeOnboarding(true);
        setCurrentHostMode(HOST_MODES["Mode Onboarding"]);
        selectActiveMode(HOST_MODES["Mode Onboarding"], "SideBar", true);
    };
    const handleSettingsNav = () => {
        setActiveButton("settings");
        navigate("/settings");
    };
    return (_jsxs("div", { className: "h-full w-full flex flex-col gap-y-6 py-5 px-7 text-sm", children: [_jsxs("div", { className: "flex-1 w-full flex flex-col items-center gap-y-6 border-b border-[#F3F4F6]", children: [_jsxs("div", { className: "w-full flex flex-col gap-y-2", children: [_jsx(Button, { label: "New Conversation", icon: _jsx(AIStarsIcon, {}), onClick: openNewChat, className: `${commonStyles} ${inactiveStyles}` }), _jsx(Button
                            // disabled={fetchingProjects}
                            , { 
                                // disabled={fetchingProjects}
                                icon: "pi pi-plus", label: "New Project", text: true, className: `${commonStyles} ${showForm ? activeStyles : inactiveStyles}`, onClick: openNewProject })] }), _jsxs("div", { className: "w-full flex flex-col", children: [_jsx(Button, { title: "Projects Dashboard", className: `w-full py-3 text-left gap-x-3 ${activeButton === HOST_MODES["Project Mode"] &&
                                    location.pathname !== "/settings"
                                    ? "text-[#2546F0]"
                                    : "text-[#374151]"}`, label: "Projects", icon: _jsx(FolderOpen, { size: 16 }), onClick: handleProjectNav }), _jsx(Button, { title: "Onboard a mode", label: "Mode Onbording", icon: _jsx(FilePlus, { size: 16 }), className: `w-full py-3 text-left gap-x-3 ${activeButton === HOST_MODES["Mode Onboarding"] &&
                                    location.pathname !== "/settings"
                                    ? "text-[#2546F0]"
                                    : "text-[#374151]"}`, onClick: handleModeOnboardingNav }), _jsx(Button, { title: "Settings", className: `w-full py-3 text-left gap-x-3 ${activeButton === "settings" || location.pathname === "/settings"
                                    ? "text-[#2546F0]"
                                    : "text-[#374151]"}`, label: "Settings", icon: _jsx(Settings, { size: 16 }), onClick: handleSettingsNav })] }), _jsxs("div", { className: "w-full flex flex-col", children: [_jsx("h4", { className: "text-sm text-[#4B5563]", children: "Recent Conversations" }), _jsx("p", { children: "Coming soon" })] })] }), _jsx("div", { className: "flex flex-col items-center gap-y-0", children: _jsx(Button, { title: "Click to log out", label: "Sign out", icon: "pi pi-sign-out", onClick: () => handleLogout(), className: "w-full px-4 py-3 mb-4 text-left gap-x-3" }) })] }));
};
export default SideBar;
